import { render, staticRenderFns } from "./AiTPythonEditorHead.vue?vue&type=template&id=a4cbb9fa&scoped=true&"
import script from "./AiTPythonEditorHead.vue?vue&type=script&lang=js&"
export * from "./AiTPythonEditorHead.vue?vue&type=script&lang=js&"
import style0 from "./AiTPythonEditorHead.vue?vue&type=style&index=0&id=a4cbb9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cbb9fa",
  null
  
)

export default component.exports